import React, { useEffect, useState } from 'react';
import FilterDropdown from './Filter/components/FilterDropdown';
import { translate } from '../services/translate';
import { DropDownDirectionType } from 'react-native-dropdown-picker';
import { StyleProp, TextStyle } from 'react-native';
import { polygonService } from '../services/central-api/polygons';
import { useCurrentApp } from '../context/CurrentApp';

interface Props {
    polygon: number;
    setPolygon: React.Dispatch<React.SetStateAction<number>>;
    polygonType: string;
    dropDownDirection?: DropDownDirectionType;
    zIndex: number;
    label?: string;
    showTooltip?: boolean;
    tooltipText?: string;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    setPendingLoading?: React.Dispatch<React.SetStateAction<boolean>>;
    companyId?: number;
    requiresCompanyId?: boolean;
}

export default function PolygonByTypeDropdown({
    polygon,
    setPolygon,
    polygonType,
    dropDownDirection,
    zIndex,
    label,
    showTooltip,
    tooltipText,
    labelStyle,
    viewStyle,
    setPendingLoading,
    companyId,
    requiresCompanyId
}: Props) {
    const { isParentApp } = useCurrentApp();

    const [polygons, setPolygons] = useState<{ label: string; value: number; }[]>([]);

    async function getPolygonsByType(polygonType: string) {
        try {
            setPendingLoading?.(true);
            const resp = await polygonService.getPolygonsByType(polygonType, isParentApp && companyId && requiresCompanyId ? companyId : undefined);
            setPolygons(resp.map((polygon) => {
                return {
                    label: polygon.name,
                    value: polygon.id
                };
            }));
        } catch (err) {
            console.error(err);
        } finally {
            setPendingLoading?.(false);
        }
    }

    useEffect(() => {
        if (requiresCompanyId && isParentApp && !companyId) {
            return;
        }

        getPolygonsByType(polygonType);
    }, [polygonType, isParentApp, companyId]);

    return (
        <FilterDropdown
            label={label}
            items={polygons}
            multiple={false}
            zIndex={zIndex}
            value={polygon}
            setValue={setPolygon}
            dropDownDirection={dropDownDirection ?? 'TOP'}
            placeholder={translate('subRegions')}
            tooltipText={tooltipText}
            showTooltip={showTooltip}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
            required={true}
        />
    );
}
